import { makeStyles } from "@/utils"
import { colors } from "@/styles/colors"

const useStyles = makeStyles((theme) => ({
	navWrapper: {
		flexGrow: 1,
		overflowY: "auto",
		minHeight: 0,
		"&::-webkit-scrollbar": { width: 4 },
		"&::-webkit-scrollbar-track": { background: "transparent" },
		"&::-webkit-scrollbar-thumb": {
			background: colors.gray[300],
			borderRadius: 2
		}
	},
	nav: {
		width: "100%",
		paddingTop: theme.spacing(1.25),
		paddingBottom: 0
	}
}))

export default useStyles
